module.exports = __webpack_public_path__ + "img/ka1-1.6beeff1d.png";